import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import CardContainer from '../../components/card/card-container.jsx';
import LinkDownload from '../../components/link/link-download';
import LabelNumber from '../../components/label/label-number.jsx';
import Api from '../../api/global.service';
import { useAuth } from '../../components/content/auth.jsx';
import env from '../../environment.js';

import NoPagination from '../../components/pagination/noPagination.jsx';
import SelectCiclo from '../../components/select/select-ciclo.jsx';
import SearchColumn from '../../components/search/search-column.jsx';
import { useCoopConfig, getUsaComiteEvaluacion } from '../../components/content/coop-config.jsx';

const renderConvValue = value => {
  const v = value != null ? parseFloat(value) || 0 : 0;
  return (
    <p className="text-right" style={{ margin: 0 }}>
      {v.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}
    </p>
  );
};

const PadronConcentradoList = () => {
  const auth = useAuth();
  const coopConfig = useCoopConfig();
  const isMiel = +coopConfig.config?.cooperativa?.producto?.id === env.productos.MIEL;
  const hasLabel = isMiel ? 'APIARIOS' : 'HAS';
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [ciclo, setCiclo] = useState({});
  const [blocking, setBlocking] = useState(true);
  const [unitConversions, setUnitConversions] = useState({});

  // const report = auth.getCertification() === 'mayacert' ? 'may_padron_concentrado' : 'padron_concentrado';

  const columns = React.useMemo(
    () => [
      {
        Header: 'INFORMACIÓN GENERAL',
        columns: [
          ...(coopConfig.mostrarLocalidadClave()
            ? [
                {
                  Header: 'CLAVE',
                  accessor: 'localidad_clave',
                  sortable: true,
                  minWidth: 50,
                },
              ]
            : []),
          {
            Header: 'CÓDIGO COMUNIDAD',
            accessor: 'id_localidad',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return (
                <p className="text-right" style={{ margin: 0 }}>
                  {value}
                </p>
              );
            },
          },
          {
            Header: 'COMUNIDAD',
            accessor: 'localidad',
            sortable: true,
            minWidth: 50,
          },
          {
            Header: 'MUNICIPIO',
            accessor: 'municipio',
            sortable: true,
            minWidth: 50,
          },
        ],
      },
      {
        Header: 'ORGÁNICOS',
        columns: [
          {
            Header: 'SOCIOS',
            accessor: 'org_socios',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value}></LabelNumber>;
            },
          },
          {
            Header: hasLabel,
            accessor: 'org_superficie',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL ' + unitConversions?.estimacion_cosecha_label,
            accessor: 'org_estimacion_cosecha_conv',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => renderConvValue(value),
          },
          {
            Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL KGS',
            accessor: 'org_estimacion_cosecha',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => renderConvValue(value),
          },
        ],
      },
      ...(+coopConfig.config?.cooperativa?.producto?.id === env.productos.MIEL
        ? [
            {
              Header: 'TRANSICIÓN',
              columns: [
                {
                  Header: 'SOCIOS',
                  id: 't_socios',
                  sortable: true,
                  minWidth: 50,
                  accessor: row =>
                    (row.t_socios || 0) + (row.t0_socios || 0) + (row.t1_socios || 0) + (row.t2_socios || 0) + (row.t3_socios || 0),
                  Cell: ({ value }) => {
                    return <LabelNumber value={value}></LabelNumber>;
                  },
                },
                {
                  Header: 'APIARIOS',
                  id: 't_superficie',
                  sortable: true,
                  minWidth: 50,
                  accessor: row =>
                    (row.t_superficie || 0) + (row.t0_superficie || 0) + (row.t1_superficie || 0) + (row.t2_superficie || 0) + (row.t3_superficie || 0),
                  Cell: ({ value }) => {
                    return <LabelNumber value={value} digits={2}></LabelNumber>;
                  },
                },
                {
                  Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL ' + unitConversions?.estimacion_cosecha_label,
                  accessor: 't_estimacion_cosecha_conv',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => renderConvValue(value),
                },
                {
                  Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL KGS',
                  accessor: 't_estimacion_cosecha',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => renderConvValue(value),
                },
              ],
            },
          ]
        : [
            //COLUMNAS CONDICIONADAS A MAYACERT
            ...(auth.getCertification() === 'mayacert'
              ? [
                  {
                    Header: 'TRANSICIÓN 3',
                    columns: [
                      {
                        Header: 'SOCIOS',
                        accessor: 't3_socios',
                        sortable: true,
                        minWidth: 50,
                        Cell: ({ value }) => {
                          return <LabelNumber value={value}></LabelNumber>;
                        },
                      },
                      {
                        Header: hasLabel,
                        accessor: 't3_superficie',
                        sortable: true,
                        minWidth: 50,
                        Cell: ({ value }) => {
                          return <LabelNumber value={value} digits={2}></LabelNumber>;
                        },
                      },
                      {
                        Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL ' + unitConversions?.estimacion_cosecha_label,
                        accessor: 't3_estimacion_cosecha_conv',
                        sortable: true,
                        minWidth: 50,
                        Cell: ({ value }) => renderConvValue(value),
                      },
                      {
                        Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL KGS',
                        accessor: 't3_estimacion_cosecha',
                        sortable: true,
                        minWidth: 50,
                        Cell: ({ value }) => renderConvValue(value),
                      },
                    ],
                  },
                ]
              : []),
            {
              Header: 'TRANSICIÓN 2',
              columns: [
                {
                  Header: 'SOCIOS',
                  accessor: 't2_socios',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => {
                    return <LabelNumber value={value}></LabelNumber>;
                  },
                },
                {
                  Header: hasLabel,
                  accessor: 't2_superficie',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => {
                    return <LabelNumber value={value} digits={2}></LabelNumber>;
                  },
                },
                {
                  Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL ' + unitConversions?.estimacion_cosecha_label,
                  accessor: 't2_estimacion_cosecha_conv',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => renderConvValue(value),
                },
                {
                  Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL KGS',
                  accessor: 't2_estimacion_cosecha',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => renderConvValue(value),
                },
              ],
            },
            {
              Header: 'TRANSICIÓN 1',
              columns: [
                {
                  Header: 'SOCIOS',
                  accessor: 't1_socios',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => {
                    return <LabelNumber value={value}></LabelNumber>;
                  },
                },
                {
                  Header: hasLabel,
                  accessor: 't1_superficie',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => {
                    return <LabelNumber value={value} digits={2}></LabelNumber>;
                  },
                },
                {
                  Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL ' + unitConversions?.estimacion_cosecha_label,
                  accessor: 't1_estimacion_cosecha_conv',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => renderConvValue(value),
                },
                {
                  Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL KGS',
                  accessor: 't1_estimacion_cosecha',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => renderConvValue(value),
                },
              ],
            },
            //COLUMNAS CONDICIONADAS A CERTIMEX
            ...(auth.getCertification() === 'mayacert'
              ? []
              : [
                  {
                    Header: 'TRANSICIÓN 0',
                    columns: [
                      {
                        Header: 'SOCIOS',
                        accessor: 't0_socios',
                        sortable: true,
                        minWidth: 50,
                        Cell: ({ value }) => {
                          return <LabelNumber value={value}></LabelNumber>;
                        },
                      },
                      {
                        Header: hasLabel,
                        accessor: 't0_superficie',
                        sortable: true,
                        minWidth: 50,
                        Cell: ({ value }) => {
                          return <LabelNumber value={value} digits={2}></LabelNumber>;
                        },
                      },
                      {
                        Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL ' + unitConversions?.estimacion_cosecha_label,
                        accessor: 't0_estimacion_cosecha_conv',
                        sortable: true,
                        minWidth: 50,
                        Cell: ({ value }) => renderConvValue(value),
                      },
                      {
                        Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL KGS',
                        accessor: 't0_estimacion_cosecha',
                        sortable: true,
                        minWidth: 50,
                        Cell: ({ value }) => renderConvValue(value),
                      },
                    ],
                  },
                ]),
          ]),
      //COLUMNAS CONDICIONADAS A MAYACERT
      ...(auth.getCertification() === 'mayacert'
        ? [
            {
              Header: 'CONVENCIONAL',
              columns: [
                {
                  Header: 'SOCIOS',
                  accessor: 'con_socios',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => {
                    return <LabelNumber value={value}></LabelNumber>;
                  },
                },
                {
                  Header: hasLabel,
                  accessor: 'con_superficie',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => {
                    return <LabelNumber value={value} digits={2}></LabelNumber>;
                  },
                },
                {
                  Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL ' + unitConversions?.estimacion_cosecha_label,
                  accessor: 'con_estimacion_cosecha_conv',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => renderConvValue(value),
                },
                {
                  Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL KGS',
                  accessor: 'con_estimacion_cosecha',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => renderConvValue(value),
                },
              ],
            },
          ]
        : []),
      //COLUMNAS CONDICIONADAS AL MODULO DE COMITE (las sanciones solo se generan ahi)
      ...(getUsaComiteEvaluacion() === 1
        ? [
            {
              Header: 'SANCIONADOS',
              columns: [
                {
                  Header: 'SOCIOS',
                  accessor: 'sancionados_socios',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => {
                    return <LabelNumber value={value}></LabelNumber>;
                  },
                },
                {
                  Header: hasLabel,
                  accessor: 'sancionados_superficie',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => {
                    return <LabelNumber value={value} digits={2}></LabelNumber>;
                  },
                },
                {
                  Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL ' + unitConversions?.estimacion_cosecha_label,
                  accessor: 'sancionados_estimacion_cosecha_conv',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => renderConvValue(value),
                },
                {
                  Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL KGS',
                  accessor: 'sancionados_estimacion_cosecha',
                  sortable: true,
                  minWidth: 50,
                  Cell: ({ value }) => renderConvValue(value),
                },
              ],
            },
          ]
        : []),
      {
        Header: 'BAJAS',
        columns: [
          {
            Header: 'SOCIOS',
            accessor: 'bajas_socios',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value}></LabelNumber>;
            },
          },
        ],
      },
      {
        Header: 'TOTALES',
        columns: [
          {
            Header: 'SOCIOS',
            accessor: 'totales_socios',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value}></LabelNumber>;
            },
          },
          {
            Header: hasLabel,
            accessor: 'totales_superficie',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => {
              return <LabelNumber value={value} digits={2}></LabelNumber>;
            },
          },
          {
            Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL ' + unitConversions?.estimacion_cosecha_label,
            accessor: 'totales_estimacion_cosecha_conv',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => renderConvValue(value),
          },
          {
            Header: 'SUMA DE ESTIMACIÓN DE COSECHA TOTAL KGS',
            accessor: 'totales_estimacion_cosecha',
            sortable: true,
            minWidth: 50,
            Cell: ({ value }) => renderConvValue(value),
          },
        ],
      },
    ],
    [auth, coopConfig, unitConversions]
  );

  const searchColumns = React.useMemo(
    () => [
      { value: 0, target: '', label: 'TODO' },
      ...(coopConfig.mostrarLocalidadClave() ? [{ value: 1, target: 'localidad_clave', label: 'CLAVE' }] : []),
      { value: 2, target: 'id_localidad', label: 'CÓDIGO COMUNIDAD' },
      { value: 3, target: 'localidad', label: 'COMUNIDAD' },
      { value: 5, target: 'municipio', label: 'MUNICIPIO' },
      { value: 6, target: 'org_socios', label: 'ORGÁNICOS -> SOCIOS' },
      { value: 7, target: 'org_superficie', label: `ORGÁNICOS -> ${hasLabel}` },
      {
        value: 8,
        target: 'org_estimacion_cosecha',
        label: 'ORGÁNICOS -> SUMA DE ESTIMACIÓN DE COSECHA TOTAL',
      },
      ...((+coopConfig.config?.cooperativa?.producto?.id === env.productos.MIEL)
        ? [
            { value: 9, target: 't_socios', label: 'TRANSICIÓN -> SOCIOS' },
            { value: 10, target: 't_superficie', label: `TRANSICIÓN -> ${hasLabel}` },
            {
              value: 11,
              target: 't_estimacion_cosecha',
              label: 'TRANSICIÓN -> SUMA DE ESTIMACIÓN DE COSECHA TOTAL',
            },
          ]
        : [
            //COLUMNAS CONDICIONADAS A MAYACERT
            ...(auth.getCertification() === 'mayacert'
              ? [
                  { value: 9, target: 't3_socios', label: 'TRANSICIÓN 3 -> SOCIOS' },
                  { value: 10, target: 't3_superficie', label: `TRANSICIÓN 3 -> ${hasLabel}` },
                  {
                    value: 11,
                    target: 't3_estimacion_cosecha',
                    label: 'TRANSICIÓN 3 -> SUMA DE ESTIMACIÓN DE COSECHA TOTAL',
                  },
                ]
              : []),
            { value: 12, target: 't2_socios', label: 'TRANSICIÓN 2 -> SOCIOS' },
            { value: 13, target: 't2_superficie', label: `TRANSICIÓN 2 -> ${hasLabel}` },
            {
              value: 14,
              target: 't2_estimacion_cosecha',
              label: 'TRANSICIÓN 2 -> SUMA DE ESTIMACIÓN DE COSECHA TOTAL',
            },
            { value: 15, target: 't1_socios', label: 'TRANSICIÓN 1 -> SOCIOS' },
            { value: 16, target: 't1_superficie', label: `TRANSICIÓN 1 -> ${hasLabel}` },
            {
              value: 17,
              target: 't1_estimacion_cosecha',
              label: 'TRANSICIÓN 1 -> SUMA DE ESTIMACIÓN DE COSECHA TOTAL',
            },
            //COLUMNAS CONDICIONADAS A CERTIMEX
            ...(auth.getCertification() === 'mayacert'
              ? []
              : [
                  { value: 18, target: 't0_socios', label: 'TRANSICIÓN 0 -> SOCIOS' },
                  { value: 19, target: 't0_superficie', label: `TRANSICIÓN 0 -> ${hasLabel}` },
                  {
                    value: 20,
                    target: 't0_estimacion_cosecha',
                    label: 'TRANSICIÓN 0 -> SUMA DE ESTIMACIÓN DE COSECHA TOTAL',
                  },
                ]),
          ]),

      //COLUMNAS CONDICIONADAS A MAYACERT
      ...(auth.getCertification() === 'mayacert'
        ? [
            { value: 21, target: 'con_socios', label: 'CONVENCIONAL -> SOCIOS' },
            { value: 22, target: 'con_superficie', label: `CONVENCIONAL -> ${hasLabel}` },
            {
              value: 23,
              target: 'con_estimacion_cosecha',
              label: 'CONVENCIONAL -> SUMA DE ESTIMACIÓN DE COSECHA TOTAL',
            },
          ]
        : []),
      ...(getUsaComiteEvaluacion() === 1
        ? [
            { value: 24, target: 'sancionados_socios', label: 'SANCIONADOS -> SOCIOS' },
            { value: 25, target: 'sancionados_superficie', label: `SANCIONADOS -> ${hasLabel}` },
          ]
        : []),
      { value: 26, target: 'bajas_socios', label: 'BAJAS -> SOCIOS' },
      { value: 27, target: 'totales_socios', label: 'TOTALES -> SOCIOS' },
      { value: 28, target: 'totales_superficie', label: `TOTALES -> ${hasLabel}` },
      {
        value: 29,
        target: 'totales_estimacion_cosecha',
        label: 'TOTALES -> SUMA DE ESTIMACIÓN DE COSECHA TOTAL',
      },
    ],
    [auth, coopConfig]
  );

  const unitConversionsLabels = data => {
    if (data) {
      const d = data[0]; // applied to headers for all columns
      setUnitConversions({
        estimacion_cosecha_label: d?.estimacion_cosecha_label ? d.estimacion_cosecha_label.toUpperCase() : 'KGS',
      });
    }
  };

  const setFilter = value => {
    setCiclo(value.target);

    setBlocking(true);

    Api.search('tx_padron_concentrado', {
      filter: [{ column: 'id_ciclo', operator: '=', value: value.target.id }],
    })
      .then(response => {
        setData(response.data);
        setOriginalData(response.data);
        unitConversionsLabels(response.data);
        setBlocking(false);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log('error: ', e);
        setBlocking(false);
      });
  };

  const setDataFilter = data => {
    setData(data);
  };

  const getBackgroundColor = (i, j) => {
    if (i === 1) {
      return 'rgb(247, 239, 231)';
    } else {
      // BAJAS sits after optional groups (SANCIONADOS, CONVENCIONAL), so its position
      // is resolved from the built columns instead of a fixed index.
      if (j === columns.findIndex(c => c.Header === 'BAJAS')) {
        return '#91918A'; //Bajas
      }

      if (auth.getCertification() === 'mayacert') {
        //ESTILOS CONDICIONADOS A MAYACERT
        switch (j) {
          case 0:
            return env.colors.neutral_600;
          case 1:
            return '#4A6700'; //Orgánico
          case 2:
            return '#7F8C8D'; //Transición 3
          case 3:
            return '#C7AE34'; //Transición 2
          case 4:
            return '#E49D2A'; //Transición 1
          case 5:
            return '#8E44AD'; //Convencional
          default:
            return env.colors.neutral_600;
        }
      } else {
        //ESTILOS CONDICIONADOS A CERTIMEX
        switch (j) {
          case 0:
            return env.colors.neutral_600;
          case 1:
            return '#4A6700'; //Orgánico
          case 2:
            return '#C7AE34'; //Transición 2
          case 3:
            return '#E49D2A'; //Transición 1
          case 4:
            return '#D87748'; //Transición 0
          default:
            return env.colors.neutral_600;
        }
      }
    }
  };

  const getColor = i => {
    return i === 1 ? 'rgb(95, 95, 89)' : 'white';
  };

  return (
    <div>
      <div className="row justify-content-between mb-2 ml-1">
        <SelectCiclo
          setFilter={evt => {
            setFilter(evt);
          }}></SelectCiclo>
        <div className="col-3 align-self-center">
          {ciclo?.uuid && auth.hasPermission('PADRON_CONCENTRADO_EXPORTAR') && (
            <div className="d-flex justify-content-end">
              <LinkDownload url={`xls/padron_concentrado/${ciclo?.uuid}`} label="Descargar Excel" icon={env.images.icon.xls}></LinkDownload>
            </div>
          )}
        </div>
      </div>

      <CardContainer height={'100%'}>
        {getUsaComiteEvaluacion() === 1 && (
          <div className="alert alert-warning" role="alert">
            Se incluyen sólo productores que tienen su evaluación del ciclo actual por el comité
          </div>
        )}

        <div className="row">
          <div className="col-10">
            <SearchColumn
              data={originalData}
              columns={searchColumns}
              setDataFilter={evt => {
                setDataFilter(evt);
              }}></SearchColumn>
          </div>
        </div>

        <NoPagination
          blocking={blocking}
          columns={columns}
          data={data}
          fnBackgroundColor={getBackgroundColor}
          fnColor={getColor}></NoPagination>
      </CardContainer>
    </div>
  );
};

export default PadronConcentradoList;
